import React, { useState } from 'react';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import Heading from '../../components/common/Heading/Heading';
import { App, Button, Popconfirm, Popover, Space } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { getPractitionerschedulesList } from '../../network/practitioners';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { ModalPractitionerSchedule } from '../../components/upeosoft/ModalApp/ModalApp';
import { deletePractitionerSchedule } from '../../network/Departments';
import { PlusOutlined } from '@ant-design/icons';

const Practitionerschedule = ({ t }) => {
  const client = useQueryClient();
  const { message } = App.useApp();
  const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deletePractitionerSchedule(id),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success('Record successfully deleted!');
        // message.success(data?.message?.message);
        // message.success('تم الحذف بنجاح');
        client.invalidateQueries({
          queryKey: [queryKeys.getDepartmentsList],
        });
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      filteredValue: [searchText],
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: '150px',
      render: (text, record) => {
        //  console.log('record:', record);
        return (
          <Space>
            {/* <ModalAppDepartments
               t={t}
               edit={true}
              //  record={record.department}
              record={editId}
               /> */}
            <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setEditId(record?.name);
                setOpen(true);
                setEdit(true);
              }}
            >
              <Button size="small" type="primary">
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.deletePractitionerSchedule}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getDepartmentsList],
    queryFn: () => getPractitionerschedulesList(),
    keepPreviousData: true,
    select: (data) => data?.data,
  });
  return (
    <div className="departments">
      <Heading title={t.settings} subTitle={t.department} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={data?.map((item) => ({
          ...item,
          key: item?.name,
        }))}
        loading={isLoading}
        setSearchText={setSearchText}
        titleBtn={t.addPractitionerSchedule}
        Placeholder={''}
        // pathBtn="/departments/add"
        // buttonModal={<ModalAppDepartments t={t} edit={false} />}
        buttonModal={
          <Button
            type="primary"
            onClick={() => {
              setOpen(true);
              setEdit(false);
            }}
          >
            <PlusOutlined size={10} /> {t.addPractitionerSchedule}
          </Button>
        }
      />
      <ModalPractitionerSchedule
        t={t}
        edit={edit}
        open={open}
        setOpen={setOpen}
        record={editId}
      />
    </div>
  );
};

export default Practitionerschedule;
